import './App.css';
import { About } from './components/About';
import { Services } from './components/Services';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import { Footer } from './components/Footer';
import { ContactForm } from './components/ContactForm';
import { ExploreMoreAboutMe } from './components/ExploreMore';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';
import Testmonials from './components/Testmonials';
function App() {
  return (
    <>
      <HelmetProvider>
        <About />
        <Services />
        <Skills />
        {/* <Projects /> */}
        <ExploreMoreAboutMe />
        <Testmonials />
        <ContactForm />
        <Footer />
      </HelmetProvider>
    </>
  );
}

export default App;
